import { Conversation, Message, Participant } from "@twilio/conversations";
import {
  AddMessagesType,
  SetParticipantsType,
  SetUnreadMessagesType,
} from "../../types";
import { handlePromiseRejection } from "../../helpers";

export async function loadUnreadMessagesCount(
  convo: Conversation,
  updateUnreadMessages: SetUnreadMessagesType
) {
  let count = 0;

  try {
    count =
      (await convo.getUnreadMessagesCount()) ??
      (await convo.getMessagesCount());
  } catch (e) {
    console.error("getUnreadMessagesCount threw an error", e);
  }

  updateUnreadMessages(convo.sid, count);
}

export async function handleParticipantsUpdate(
  participant: Participant,
  updateParticipants: SetParticipantsType
) {
  const result = await participant.conversation.getParticipants();
  updateParticipants(result, participant.conversation.sid);
}

export async function upsertMessage(
  message: Message,
  sidRef: React.MutableRefObject<string>,
  upsertMessages: AddMessagesType,
  updateUnreadMessages: SetUnreadMessagesType,
  addNotifications: (err: any) => void
) {
  await handlePromiseRejection(async () => {
    if (sidRef.current === message.conversation.sid) {
      await message.conversation.advanceLastReadMessageIndex(message.index);
    }
    upsertMessages(message.conversation.sid, [message]);
    await loadUnreadMessagesCount(message.conversation, updateUnreadMessages);
  }, addNotifications);
}
